export default "__VITE_ASSET__Qn1DjRse__"